var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',_vm._g(_vm._b({staticClass:"base-button",class:[{ 'base-button--outline': _vm.outline }, _vm.sizeBtn ]},'button',_vm.$attrs,false),_vm.$listeners),[_c('div',{staticClass:"base-button__content"},[_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }